<!-- @component
    A fake scrollbar component that is used to scroll the monitored element.
    It is used to present a fixed scrollbar on the bottom of the screen to allow
    horizontal scrolling on tall elements.
-->
<script lang="ts">
  import { untrack } from 'svelte';

  let {
    monitored,
    visible,
  }: {
    monitored: HTMLElement;
    visible?: boolean;
  } = $props();

  let fakebarElem: HTMLDivElement;
  let width = $state(0);
  let left = $state(0);
  let totalSize = $state(0);

  const fakeScrollbar = () => {
    const monitoredRect = monitored.getBoundingClientRect();

    width = Math.round(monitoredRect.width);
    left = monitoredRect.left;
    totalSize = monitored.scrollWidth;
  };

  const onFakebarScroll = (e: Event) => {
    e.preventDefault();

    if (monitored.scrollLeft !== fakebarElem.scrollLeft)
      monitored.scrollLeft = fakebarElem.scrollLeft;
  };

  const onMonitoredScroll = (e: Event) => {
    if (e.currentTarget) fakebarElem.scrollLeft = (e.currentTarget as HTMLElement).scrollLeft;
  };

  $effect(() => {
    if (!monitored) return;

    const resizeObserver = new ResizeObserver(fakeScrollbar);

    resizeObserver.observe(monitored);
    monitored.addEventListener('scroll', onMonitoredScroll);
    untrack(() => fakeScrollbar());

    return () => {
      monitored.removeEventListener('scroll', onMonitoredScroll);
      resizeObserver.disconnect();
    };
  });
</script>

<div
  class={['fixed bottom-0 overflow-x-auto', !visible && 'hidden']}
  style="left:{left}px;width:{width}px"
  onscroll={onFakebarScroll}
  bind:this={fakebarElem}
>
  <div style="height:1px;width:{totalSize}px;"></div>
</div>
